import { render, staticRenderFns } from "./submissions-table-row-placeholder.vue?vue&type=template&id=4c0d4528&scoped=true&"
import script from "./submissions-table-row-placeholder.vue?vue&type=script&lang=ts&"
export * from "./submissions-table-row-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./submissions-table-row-placeholder.vue?vue&type=style&index=0&id=4c0d4528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0d4528",
  null
  
)

export default component.exports